var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 735.415,
    height: 800.127,
    viewBox: "0 0 735.415 800.127",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-783.001 -139.936)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1257.808 380.374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.091,110.866l-29.971,9.848V77.59H366.3Z",
    transform: "translate(-239.038 -18.333)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.855,
    cy: 29.855,
    rx: 29.855,
    ry: 29.855,
    transform: "translate(73.937 11.479)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.252,69.817l-4.112,5L341.7,61.79s-9.5.5-9.5-6.565-8.719-7.245-8.719-7.245S311.132,26.429,336.7,32.108c0,0,17.727-12.152,26.55-1.762,0,0,27.033,13.615,19.293,37.319L369.692,92.1l-2.914-5.529S368.539,63.344,353.252,69.817Z",
    transform: "translate(-241.858 -26.145)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.119,
    height: 34.221,
    transform: "translate(114.158 501.134)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.091,514.06c-2.534,0-4.792-.058-6.5-.219-6.4-.587-12.52-5.321-15.6-8.086a4.367,4.367,0,0,1-1.106-4.93h0a4.332,4.332,0,0,1,2.822-2.5l16.932-4.838,27.414-18.5.311.553a48.854,48.854,0,0,1,3.709,8.328,3.706,3.706,0,0,1-.265,3.087,2.948,2.948,0,0,1-1.267,1.06c.5.518,2.05,1.578,6.842,2.338,6.992,1.106,8.466-6.139,8.524-6.439l.046-.242.207-.138c3.329-2.142,5.379-3.121,6.082-2.914.438.127,1.175.357,3.168,20.088a20.285,20.285,0,0,1,.645,9.5c-1.025,4.723-21.666,3.1-25.8,2.73-.115.012-15.573,1.117-26.158,1.117h0Z",
    transform: "translate(-243.428 42.005)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.122,
    height: 34.225,
    transform: "translate(170.785 465.2) rotate(-39.564)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.689,487.187c-1.958,1.613-3.732,3.006-5.137,3.974-5.31,3.628-13.039,3.882-17.162,3.709a4.38,4.38,0,0,1-4-3.1h0a4.37,4.37,0,0,1,.576-3.732l9.963-14.525,9.33-31.721.587.23a49.015,49.015,0,0,1,8.167,4.054,3.714,3.714,0,0,1,1.762,2.546,2.939,2.939,0,0,1-.3,1.636c.714.081,2.58-.092,6.761-2.557,6.093-3.594,2.615-10.125,2.453-10.4l-.115-.219.069-.23c1.2-3.778,2.154-5.828,2.833-6.116.426-.184,1.129-.484,15.239,13.465a20.1,20.1,0,0,1,6.554,6.911c2.223,4.3-14.72,16.206-18.141,18.544-.081.081-11.288,10.781-19.443,17.531h0Z",
    transform: "translate(-230.986 35.279)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.71,232.11h82.736L381.063,505.589H353.488l-36.766-273.48h0Z",
    transform: "translate(-242.44 5.128)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.558,247.176,316.707,232.11l8.42,150.406,94.231,89.624,23.5-19.408L387.95,381.491Z",
    transform: "translate(-242.436 5.128)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.454,100.3l28.972-11.024L385,111.938c16.126,28.2,16.192,58.425,12.24,90.673l2.206,51.58H316.709Z",
    transform: "translate(-242.438 -16.953)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.875,246.982c-6.865,5.2-9.618,13.039-6.151,17.531s11.852,3.928,18.717-1.267a20.682,20.682,0,0,0,6.473-7.844l28.8-22.369L296.4,219.35,269.2,242.859a21.182,21.182,0,0,0-9.353,4.124h.023Z",
    transform: "translate(-252.225 3.19)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.826,251.421,323.654,195.8,356.4,132.99a24.943,24.943,0,1,1,42.606,25.755l-47.1,67.728-.069.1-72.059,42.434-10.942-17.6h-.012Z",
    transform: "translate(-249.716 -11.96)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.18,489a1.666,1.666,0,0,0,1.469,1.814H749.118a1.854,1.854,0,0,0,0-3.628H16.649A1.666,1.666,0,0,0,15.18,489Z",
    transform: "translate(767.827 449.249)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.52,268.471h-4.38V148.58a69.39,69.39,0,0,0-69.39-69.39h-254a69.39,69.39,0,0,0-69.39,69.39V806.3a69.39,69.39,0,0,0,69.39,69.39h254a69.39,69.39,0,0,0,69.39-69.39V353.8h4.38Z",
    transform: "translate(575.062 60.746)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 358,
    height: 760,
    rx: 50,
    transform: "translate(861 158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0H92a16,16,0,0,1,0,32H16A16,16,0,0,1,16,0Z",
    transform: "translate(986 166)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-563 125)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    transform: "translate(1448 105)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.65,97.88c0-1.131.926-1.576,2.466-1.576a16.268,16.268,0,0,1,7.218,1.865V91.335A19.133,19.133,0,0,0,133.128,90c-5.907,0-9.828,3.08-9.828,8.228,0,8.024,11.055,6.749,11.055,10.213,0,1.335-1.167,1.768-2.791,1.768a18.108,18.108,0,0,1-7.94-2.322v6.917a20.106,20.106,0,0,0,7.94,1.66c6.051,0,10.213-3,10.213-8.2C141.73,99.6,130.65,101.14,130.65,97.88Z",
    transform: "translate(1339.595 25.89)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24,0A24,24,0,1,1,0,24,24,24,0,0,1,24,0Z",
    transform: "translate(1147 230)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0H67a8,8,0,0,1,8,8v8a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(885 314)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0H67a8,8,0,0,1,8,8v8a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(972 314)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0H67a8,8,0,0,1,8,8v8a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(1059 314)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0H73V24H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(1146 314)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0H32a8,8,0,0,1,8,8V32a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(885 380)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.859,369.693a2.137,2.137,0,0,1-1.71-.855l-5.242-6.989a2.137,2.137,0,1,1,3.42-2.565l3.429,4.572,8.808-13.211a2.137,2.137,0,0,1,3.557,2.371l-10.483,15.725a2.138,2.138,0,0,1-1.719.951Z",
    transform: "translate(601.52 40.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.806-71.38V-74.1a8.278,8.278,0,0,1-5.2-1.951,6.489,6.489,0,0,1-2.043-4.808H9.255a3.263,3.263,0,0,0,1.107,2.37,4.557,4.557,0,0,0,2.451,1.018v-6.507l-1.124-.311a9.126,9.126,0,0,1-4.084-2.133,5.009,5.009,0,0,1-1.464-3.753A5.891,5.891,0,0,1,7-93.361,6.393,6.393,0,0,1,9.37-95.582,8.587,8.587,0,0,1,12.806-96.6V-99.38h1.681v2.768a8.286,8.286,0,0,1,3.537.971,6.379,6.379,0,0,1,2.361,2.208,6,6,0,0,1,.9,3.091H17.656a2.961,2.961,0,0,0-.969-1.99,3.977,3.977,0,0,0-2.2-.927v6.138l.939.249a13.533,13.533,0,0,1,2.949,1.141,6.488,6.488,0,0,1,2.3,2,5.332,5.332,0,0,1,.888,3.165,5.93,5.93,0,0,1-1.857,4.49,8.022,8.022,0,0,1-5.219,1.973v2.723Zm1.681-6.107a4.277,4.277,0,0,0,2.417-1.03,2.7,2.7,0,0,0,.918-2.076,2.12,2.12,0,0,0-.911-1.848,7.993,7.993,0,0,0-2.422-1.067ZM12.806-87.572v-5.667a3.678,3.678,0,0,0-2.122.971,2.529,2.529,0,0,0-.763,1.854,2.138,2.138,0,0,0,.888,1.848,7.071,7.071,0,0,0,2,.995Z",
    transform: "translate(1165.435 491.38)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0H185a8,8,0,0,1,8,8v8a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(944 394)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0H67a8,8,0,0,1,8,8v8a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(944 434)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,.5H0v-1H310Z",
    transform: "translate(885 482)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 126.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0H32a8,8,0,0,1,8,8V32a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(885 380)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.859,369.693a2.137,2.137,0,0,1-1.71-.855l-5.242-6.989a2.137,2.137,0,1,1,3.42-2.565l3.429,4.572,8.808-13.211a2.137,2.137,0,0,1,3.557,2.371l-10.483,15.725a2.138,2.138,0,0,1-1.719.951Z",
    transform: "translate(601.52 40.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.806-71.38V-74.1a8.278,8.278,0,0,1-5.2-1.951,6.489,6.489,0,0,1-2.043-4.808H9.255a3.263,3.263,0,0,0,1.107,2.37,4.557,4.557,0,0,0,2.451,1.018v-6.507l-1.124-.311a9.126,9.126,0,0,1-4.084-2.133,5.009,5.009,0,0,1-1.464-3.753A5.891,5.891,0,0,1,7-93.361,6.393,6.393,0,0,1,9.37-95.582,8.587,8.587,0,0,1,12.806-96.6V-99.38h1.681v2.768a8.286,8.286,0,0,1,3.537.971,6.379,6.379,0,0,1,2.361,2.208,6,6,0,0,1,.9,3.091H17.656a2.961,2.961,0,0,0-.969-1.99,3.977,3.977,0,0,0-2.2-.927v6.138l.939.249a13.533,13.533,0,0,1,2.949,1.141,6.488,6.488,0,0,1,2.3,2,5.332,5.332,0,0,1,.888,3.165,5.93,5.93,0,0,1-1.857,4.49,8.022,8.022,0,0,1-5.219,1.973v2.723Zm1.681-6.107a4.277,4.277,0,0,0,2.417-1.03,2.7,2.7,0,0,0,.918-2.076,2.12,2.12,0,0,0-.911-1.848,7.993,7.993,0,0,0-2.422-1.067ZM12.806-87.572v-5.667a3.678,3.678,0,0,0-2.122.971,2.529,2.529,0,0,0-.763,1.854,2.138,2.138,0,0,0,.888,1.848,7.071,7.071,0,0,0,2,.995Z",
    transform: "translate(1165.435 611.88)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0H185a8,8,0,0,1,8,8v8a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(944 514.5)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0H67a8,8,0,0,1,8,8v8a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(944 554.5)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,.5H0v-1H310Z",
    transform: "translate(885 602.5)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0H32a8,8,0,0,1,8,8V32a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(885 380)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.859,369.693a2.137,2.137,0,0,1-1.71-.855l-5.242-6.989a2.137,2.137,0,1,1,3.42-2.565l3.429,4.572,8.808-13.211a2.137,2.137,0,0,1,3.557,2.371l-10.483,15.725a2.138,2.138,0,0,1-1.719.951Z",
    transform: "translate(601.52 40.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.806-71.38V-74.1a8.278,8.278,0,0,1-5.2-1.951,6.489,6.489,0,0,1-2.043-4.808H9.255a3.263,3.263,0,0,0,1.107,2.37,4.557,4.557,0,0,0,2.451,1.018v-6.507l-1.124-.311a9.126,9.126,0,0,1-4.084-2.133,5.009,5.009,0,0,1-1.464-3.753A5.891,5.891,0,0,1,7-93.361,6.393,6.393,0,0,1,9.37-95.582,8.587,8.587,0,0,1,12.806-96.6V-99.38h1.681v2.768a8.286,8.286,0,0,1,3.537.971,6.379,6.379,0,0,1,2.361,2.208,6,6,0,0,1,.9,3.091H17.656a2.961,2.961,0,0,0-.969-1.99,3.977,3.977,0,0,0-2.2-.927v6.138l.939.249a13.533,13.533,0,0,1,2.949,1.141,6.488,6.488,0,0,1,2.3,2,5.332,5.332,0,0,1,.888,3.165,5.93,5.93,0,0,1-1.857,4.49,8.022,8.022,0,0,1-5.219,1.973v2.723Zm1.681-6.107a4.277,4.277,0,0,0,2.417-1.03,2.7,2.7,0,0,0,.918-2.076,2.12,2.12,0,0,0-.911-1.848,7.993,7.993,0,0,0-2.422-1.067ZM12.806-87.572v-5.667a3.678,3.678,0,0,0-2.122.971,2.529,2.529,0,0,0-.763,1.854,2.138,2.138,0,0,0,.888,1.848,7.071,7.071,0,0,0,2,.995Z",
    transform: "translate(1165.435 732.379)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0H185a8,8,0,0,1,8,8v8a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(944 635)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0H67a8,8,0,0,1,8,8v8a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(944 675)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,.5H0v-1H310Z",
    transform: "translate(885 723)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0H302a8,8,0,0,1,8,8V120a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(885 751)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(922.5 771.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.26,
    cy: 5.26,
    r: 5.26,
    transform: "translate(220.838 0)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.324,42.513l.62.62L229.511,74.565,219.648,64.7,202.333,82.018l-21.26-21.26L144.909,96.922,128.47,80.483,92.525,116.429,72.361,96.264l-36.95,36.951-.62-.62,37.57-37.57,20.165,20.165,35.945-35.945,16.438,16.438,36.164-36.164,21.26,21.26,17.315-17.315,9.863,9.864Z",
    transform: "translate(-34.791 -42.513)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.26,
    cy: 5.26,
    r: 5.26,
    transform: "translate(139.486 13.022)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.26,
    cy: 5.26,
    r: 5.26,
    transform: "translate(32.528 47.652)",
    fill: "#090814"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.813f0fb209f3dccdc0ce8720c67a9669.svg";
export { ForwardRef as ReactComponent };